<template>
  <div class="operation-detail">
    <div class="content" :class="{'content-moreFile':fileList.length > 3}">
      <div class="title">
        {{ title }}
      </div>
      <div class="date">
        {{ date }}
      </div>
      <div class="message" v-html="content"></div>
    </div>
    <div class="box-bottom" v-if="fileList.length != 0">
      <div
        class="pdf-file"
        v-for="(item, index) of fileList"
        :key="index"
        @click="clickTips(item)"
      >
        <img
          class="pdf-icon"
          :src="require('@/assets/img/projectAppoint/pdf.png')"
        />
        <div class="pdf-name">{{ item.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import moduleMixins from '@/mixins/moduleMixins'
export default {
  name: 'CommonDetail',
  components: {},
  mixins: [moduleMixins],
  props: {},
  data() {
    return {
      rid: '',
      title: '',
      date: '',
      content: '',
      fileList: []
    }
  },
  computed: {
    navTitle() {
      return this.title
    }
  },
  watch: {},
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
    fetchWorkguideId() {},
    clickTips(item) {
      console.log('item', item)

      const params = this.UrlParamHash(item.url)
      console.log('params', params)
      let url =
        'macroPath=' +
        params['macroPath'] +
        '&fileName=' +
        decodeURI(params['fileName'])

      if (window.__wxjs_environment === 'miniprogram') {
        wx.miniProgram.navigateTo({
          url: '/pages/downloadFile/downloadFile?' + url
        })
      } else {
        this.$toast.fail('请使用小程序预览')
      }
    },
    UrlParamHash(url) {
      var params = [],
        h
      var hash = url.slice(url.indexOf('?') + 1).split('&')
      //  console.log(hash)
      for (var i = 0; i < hash.length; i++) {
        h = hash[i].split('=') //
        params[h[0]] = h[1]
        //   console.log(h)
      }
      return params
    }
  },
  created() {},
  mounted() {
    this.rid = this.$route.query.rid
    this.onload()
  }
}
</script>
<style lang="scss" scoped>
.operation-detail {
  height: 100vh;
  background: #ffffff;
  ::v-deep img {
    width: 100%;
  }
  
  .content {
    padding: 0 15px 150px 15px;
    background: #ffffff;
    .title {
      font-size: 17px;
      font-weight: bold;
      color: #333333;
      line-height: 30px;
      padding-top: 20px;
    }
    .date {
      font-size: 14px;
      font-weight: 500;
      color: #999999;
      line-height: 21px;
      margin-top: 15px;
    }
    .message {
      margin-top: 20px;
      font-size: 14px;
      color: #333333;
      line-height: 21px;
      
      ::v-deep p {
        text-indent: 2em;
        img {
          margin-left: -2em;
        }
      }
    }
  }
  .content-moreFile{
    padding: 0 15px 45vw 15px;
  }
  .box-bottom {
    position: fixed;
    bottom: 0;
    width: 100%;
    padding: 0px 16px;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.15);
    background-color: #ffffff;

    overflow: hidden;
    overflow-y: scroll;
    max-height: 45vw;
    .pdf-file {
      display: flex;
      align-items: center;
      /* height: 50px; */
      height: 40px;

      .pdf-icon {
        width: 16px;
        height: 16px;
      }
      .pdf-name {
        font-size: 12px;
        font-weight: 500;
        text-decoration: underline;
        color: #1d84ff;
        line-height: 18px;
        padding-left: 10px;
      }
    }
  }
}
</style>
